import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { DetailFormComponentsEnum } from "@/lib/enum/detail-form-components.enum";
import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { Form, FormConfig, IsFormable } from "@/lib/formable";
import { RulesEnum } from "@/lib/rules/rules.map";
import { parsePhone } from "@/lib/utility/parsePhone";
import { MrfiktivPartialContactDocumentGen } from "@/services/mrfiktiv/v1/data-contracts";

@IsFormable
@IsFilterable
class ContactPartialBase implements MrfiktivPartialContactDocumentGen {
  /**
   * @inheritdoc
   */
  @FormConfig({
    category: "common.nouns.contact",
    searchKeywords: ["objects.contact.email", "common.nouns.contact"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "objects.contact.email"
    },
    rules: [RulesEnum.EMAIL_RULE_OPTIONAL],
    clearable: true
  })
  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contact.email" })
  email?: string | null;
  /**
   * @inheritdoc
   */
  _phone?: string | null;

  _countryCode?: CountryCodeEnum;

  /**
   * Get the phone number in international format
   * @inheritdoc
   */
  @FormConfig({
    category: "common.nouns.contact",
    searchKeywords: ["objects.contact.phone", "common.nouns.contact"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: { label: "objects.contact.phone" },
    rules: [RulesEnum.PHONE_RULE_OPTIONAL],
    clearable: true
  })
  @FilterConfig({ type: FilterTypes.STRING, displayName: "common.nouns.contact" })
  get phone(): string | undefined | null {
    return this._phone;
  }

  /**
   * Set the phone number and transform it to international format using libphonenumber
   * @param value Phone number to set
   */
  set phone(value: string | undefined | null) {
    if (value) {
      this._phone = parsePhone(value, this._countryCode);
    } else {
      this._phone = value;
    }
  }

  constructor(contact?: Partial<MrfiktivPartialContactDocumentGen> | null, countryCode?: CountryCodeEnum) {
    this._countryCode = countryCode;
    this.email = contact?.email;
    this.phone = contact?.phone;
  }

  get dto(): MrfiktivPartialContactDocumentGen {
    return {
      email: this.email,
      phone: this.phone
    };
  }
}

type IContactPartial = ContactPartialBase;
const ContactPartial = Form.createForClass(Filter.createForClass(ContactPartialBase));

export { ContactPartial, IContactPartial };
